import React from 'react';
import PropTypes from 'prop-types';

import useAppContext from '../../context/useAppContext';

import PartnerModel from '../../models/partner';

import { Route, Switch, Redirect, useHistory } from 'react-router-dom';
import Template from '../../components/template/template';
import Loading from '../../components/loading';

import PartnerDetails from './partnerDetails';
import PartnerUser from './partnerUser';
import Partners from './Partners';
import PartnerBatchBookings from './PartnerBatchBookings';
import PartnerBatchBookingsList from './partnerBatchBookingsList';
import PartnerBatchBookingDetail from './partnerBatchBookingDetail.js';
import Mailing from './mailing/templateList';
import PageError from '../error/pageError';
import { ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';

export default function PartnerDetailRouter({ match: { path, url }, organization, partnerId }) {
    const [context, setContext] = useAppContext();
    const toast = React.useContext(ToastContext);
    const history = useHistory();
    const { t } = useTranslation();

    const [partner, loading] = PartnerModel.useApiModel(
        {
            id: partnerId,
            organizationId: organization.pk,
            onError: e => {
                if (e.code === 404) {
                    toast.error(t('pageNotFound'));
                } else {
                    toast.error(t('ticket.common.toast_error'));
                }

                history.push(`/ticket/O${organization.id}/partners`);
            }
        },
        [partnerId, organization]
    );

    React.useEffect(() => {
        if (partner && (!context.partner || context.partner.pk !== partner.pk || context.partner.status !== partner.status)) {
            setContext({ partner });
        }
    }, [partner]);

    if (loading || !context.partner || context.partner.pk !== partnerId) {
        return <Loading />;
    }

    return (
        <Template organization={organization} partner={context.partner}>
            <Switch>
                <Route
                    exact
                    path={`${path}/`}
                    render={() => {
                        let redirect = `${url}/dashboard`;
                        if (url[url.length - 1] === '/') {
                            redirect = `${url}dashboard`;
                        }

                        return <Redirect to={redirect} />;
                    }}
                />

                <Route
                    exact
                    path={`${path}/dashboard`}
                    render={({
                        match: {
                            params: { partnerId }
                        }
                    }) => <PartnerDetails organization={organization} partnerId={partnerId} />}
                />
                <Route
                    exact
                    path={`${path}/users`}
                    render={({
                        match: {
                            params: { partnerId }
                        }
                    }) => <PartnerUser organization={organization} partnerId={partnerId} />}
                />
                <Route exact path={`${path}/edit`} render={basenameProps => <Partners organization={organization} partnerId={basenameProps.match.params.partnerId} />} />
                <Route
                    exact
                    path={`${path}/batches`}
                    render={basenameProps => <PartnerBatchBookingsList organization={organization} partnerId={basenameProps.match.params.partnerId} />}
                />
                <Route
                    exact
                    path={`${path}/batches/new`}
                    render={basenameProps => <PartnerBatchBookings organization={organization} partnerId={basenameProps.match.params.partnerId} />}
                />
                <Route
                    exact
                    path={`${path}/batches/:batchBookingId`}
                    render={basenameProps => (
                        <PartnerBatchBookingDetail
                            organization={organization}
                            partnerId={basenameProps.match.params.partnerId}
                            batchBookingId={basenameProps.match.params.batchBookingId}
                        />
                    )}
                />
                <Route exact path={`${path}/mailing`} render={basenameProps => <Mailing organization={organization} partnerId={basenameProps.match.params.partnerId} />} />
                <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}/partners/${partnerId}/dashboard`} />} />
            </Switch>
        </Template>
    );
}

PartnerDetailRouter.propTypes = {
    match: PropTypes.object,
    organization: PropTypes.object,
    partnerId: PropTypes.number
};
